import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.9995 23.3145H2.99951V20.3145H20.9995V23.3145Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.313 9.89941L12.4136 19.7988L9.58545 16.9707L8.58545 17.9707H4.92822L2.51416 15.5566L5.34229 12.7275L2.51416 9.89941L12.4136 0L22.313 9.89941ZM5.34229 15.5566L5.75732 15.9707H7.75635L8.17139 15.5566L6.75635 14.1426L5.34229 15.5566Z"}}]};

const FontBackgroundFilled = Vue.extend<IconProps>({
  name: 'FontBackgroundFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'font-background-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FontBackgroundFilled;
